





























import { grabTodoListInstance } from '@/model/GrabTodoListClass';
import { AccountModule } from '@/store/modules/account';
import { Component, Prop, Vue } from 'vue-property-decorator';
import TodoListTable from './todoListTable.vue';

type IGrabTodoInfo = ITodo.IResponse.IGrabTodoInfo;

@Component({
  name: 'GrabTodoList',
  components: {
    TodoListTable,
  },
})
export default class GrabTodoList extends Vue {
  @Prop({ default: false }) private spinning!: boolean;
  @Prop({ required: true, default: () => [] }) private todos!: IGrabTodoInfo[];
  @Prop({ default: ''}) private activeKey!: string;
  private currentTodo: IGrabTodoInfo | null = null;
  private visible = false;
  private comment = '';
  private confirmLoading = false;
  private goModulePage(moduleId: string) {
    this.$router.push({
      name: 'Module',
      params: {
        id: moduleId,
      },
    });
  }
  private handleAcceptTodo() {
    if (!this.currentTodo) {
      return;
    }
    this.confirmLoading = true;
    grabTodoListInstance.requestAcceptTodo({
      todoId: this.currentTodo.id,
      comment: this.comment,
      owner: AccountModule.userDetailInfo!.id,
      ownerName: AccountModule.name,
    }).then((res) => {
      this.currentTodo!.ownerName = AccountModule.name;
      this.currentTodo!.owner = AccountModule.userDetailInfo!.id;
      this.currentTodo!.grabComment = this.comment;
      this.$message.success('Success');
      this.visible = false;
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.confirmLoading = false;
    });
  }
  private handleShowModal(todo: IGrabTodoInfo) {
    this.currentTodo = todo;
    this.visible = true;
    this.comment = '';
  }
  private handleCancel() {
    this.visible = false;
  }
}
